import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";


@Component({
    selector: 'ea-model-draft-object-component',
    templateUrl: 'ea-model-draft-object.component.html',
    standalone: false
})
export class EaModelDraftObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    onObjectChanged() {
        const dto = this.dto as any;
        if (dto?.schemaName) {
            this.setPageTitle(`Model Draft: ${dto.schemaName}`);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
